module.exports = __webpack_public_path__ + "img/third2.a54f193d.svg";